import React from 'react';
import Email from 'oldAssets/images/icons/email.svg';
import styles from './PhotoAndContact.module.scss';

const ContactIcon = ({ link, icon }) => (
  <a href={ link } className = { styles.ContactIcon }>
    <img src={ icon || Email } />
  </a>
);

export default ContactIcon;
